export const dateFormatDefault = 'MM/dd/yyyy';
export const dateFormatDefaultWithTime = 'MM/dd/yyyy hh:mm a';
export const dateFormatDefaultWithTimeAt = "MM/dd/yyyy 'at' hh:mm a";
export const dateFormatDefaultWith24HourTime = 'MM/dd/yyyy HH:mm';
